import moment from 'moment-timezone';

export const SCHEDULE_TIME_ZONE = 'America/Edmonton';

// The calendar's moment localizer supports a default zone. Bundle the IANA data
// with the app so bookings do not depend on the browser's timezone database.
moment.tz.setDefault(SCHEDULE_TIME_ZONE);
moment.updateLocale('en', { week: { dow: 1 } });
export const scheduleMoment = moment;

export function atScheduleTime(day, hour, minute = 0) {
  return moment(day).tz(SCHEDULE_TIME_ZONE)
    .hour(hour).minute(minute).second(0).millisecond(0).toDate();
}

// react-datepicker requires browser-local Date fields. Only its boundary uses
// these wall-clock carrier dates; application state and API values are instants.
export function toPickerDate(instant) {
  if (!instant) return null;
  const parts = moment(instant).tz(SCHEDULE_TIME_ZONE).toArray();
  return new Date(...parts);
}

export function fromPickerDate(date) {
  if (!date) return null;
  return moment.tz([
    date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(),
    date.getMinutes(), date.getSeconds(), date.getMilliseconds(),
  ], SCHEDULE_TIME_ZONE).toDate();
}

export function formatScheduleDate(instant, options = {
  year: 'numeric', month: 'numeric', day: 'numeric',
}, locale = 'en-US') {
  // Intl handles locale formatting only. Moment's bundled rules provide the
  // Edmonton fields, so stale browser timezone rules cannot change the time.
  const parts = moment(instant).tz(SCHEDULE_TIME_ZONE).toArray();
  return new Date(Date.UTC(...parts)).toLocaleDateString(locale, {
    ...options, timeZone: 'UTC',
  });
}

export function scheduleSortValue(timestamp) {
  if (timestamp === 'Completed') return Infinity;
  if (!timestamp || timestamp === 'Not Scheduled') return Number.MAX_VALUE;
  return moment.parseZone(timestamp, moment.ISO_8601, true).valueOf();
}
